// extracted by css-extract-rspack-plugin
module.exports =  {"exam-activity":"Exam-WfI5__exam-activity","fullscreen-overlay":"Exam-lI0X__fullscreen-overlay","blur-overlay":"Exam-Al0C__blur-overlay","pagination":"Exam-KmPX__pagination"};